module.exports = __webpack_public_path__ + "img/xt.ee8e6dd1.png";